import React from "react";
import logo from "./../../assets/img/Template-logo.png";
import mark from "./../../assets/img/mark.jpg";
import { useState, useEffect } from "react";
import { API_Link, validateHeader } from "../../commons/Constants";
import axios from "axios";
import { color } from "highcharts";
import { Link } from "react-router-dom";
import pdficon from "./../../assets/img/pdficon.png";
import gif from "../../assets/img/spin.gif";
import { setLoading } from "../../features/setting/apiSlice";
import store from "../../store";
import { useDispatch } from "react-redux";
import EvidenceTableSingle from "../evidenceTableSingle";
function IB() {
  const dispatch = useDispatch();
  const MD5hash = validateHeader();
  const [data, setData] = useState([]);
  const [isLoadingData, setisLoadingData] = useState(false);

  const [reviewData, setreviewData] = useState([]);
  // const [Authors, setAuthors] = useState([]);
  const [interventions, setInterventions] = useState([]);
  const [outcomes, setOutcomes] = useState([]);
  const [participants, setParticipants] = useState([]);
  const [punchline, setPunchline] = useState([]);
  const [picoSearchs, setPicoSearches] = useState([]);
  const [isLoadingPicoSearchs, setisLoadingPicoSearchs] = useState(false);

  const [abstract, setAbstract] = useState([]);
  const [prismaValue, setPrismaValue] = useState([]);
  const [isLoadingPrismaValue, setisLoadingPrismaValue] = useState(false);

  const [reasons, setReasons] = useState([]);
  const [title, setTitle] = useState([]);
  // const [Author, setAuthor] = useState([]);
  const [year, setYear] = useState([]);
  const [pages, setPages] = useState([]);
  const [pmid, setPmid] = useState([]);
  const [judgement, setJudgment] = useState([]);
  const [rct, setRct] = useState([]);
  const [findings, setFindings] = useState([]);
  const [isLoadingMultidata, setisLoadingMultidata] = useState(false);
  const [multidata, setMultidata] = useState([]);
  const [maintitle, setMaintitle] = useState([]);
  const [title1, setTitle1] = useState([]);
  const [biasesData, setBiasesData] = useState([]);
  const [judgementData, setJudgmentData] = useState([]);
  const [isLoadingJudgementData, setisLoadingJudgementData] = useState(false);

  const [picoData, setPicoData] = useState([]);
  const [isLoadingPicoData, setisLoadingPicoData] = useState(false);

  const styles = {
    tdStyling: {
      backgroundColor: "#eaefef",
      padding: "5px",
      border: "1px solid #000",
      verticalAlign: "top",
    },
    thStyling: {
      border: "1px solid black",
      textAlign: "center",
      color: "#219ebc",
      backgroundColor: "#d9e2f3",
    },
    tableStyling: {
      borderCollapse: "collapse",
      width: "100%",
      padding: "10px",
      height: "auto",
      backgroundColor: "#00b0f0",
      color: "white",
    },
  };

  const getReviews = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;
    const studyId = localStorage.getItem("studyId");
    var config = {
      method: "get",
      url: `${API_Link}getReviews`,
      headers: {
        "misr-auth": MD5hash,
        Authorization: `Bearer ${token}`,
      },
      params: {
        id: studyId,
      },
    };
    axios(config)
      .then(function (response) {
        const APIresponse = response.data.reviews;
        console.log("DATA is here :", APIresponse);
        setMaintitle(APIresponse);
        const title1 = APIresponse[0].title;
        console.log("TITLE:", title1);
        setTitle1(title1);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getReviewData = () => {
    setisLoadingMultidata(true);
    store.dispatch(
      setLoading({ apiName: "getReviewData(IB)", isLoading: true })
    );

    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;
    const studyId = localStorage.getItem("studyId");

    var config = {
      method: "get",
      url: `${API_Link}getExtractedReportJson?review_id=${studyId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    axios(config)
      .then(function (response) {
        const Response1 = response.data.data[0].report_json;
        const Response2 = JSON.parse(Response1);
        console.log("Response2: ", Response2);
        const ResponseData = Response2.article_data[0];
        const ResponseDataArray = response.data.data;
        const abstracts = []; // Array to store abstracts
        for (let i = 0; i < ResponseDataArray.length; i++) {
          const reportJson = ResponseDataArray[i].report_json;
          const parsedReport = JSON.parse(reportJson);
          const articleData = parsedReport.article_data;

          for (let j = 0; j < articleData.length; j++) {
            const abstract = articleData[j].dubious.abstract;

            abstracts.push(abstract);
          }
        }
        console.log("abstracts: ", abstracts);

        setAbstract(abstracts);

        setreviewData(ResponseData);
        const title = ResponseData.dubious.title;
        console.log("title: ", title);
        setTitle(title);
        const interventions = ResponseData.ml.pico_span.interventions;
        setInterventions(interventions);

        const outcomes = ResponseData.ml.pico_span.outcomes;
        setOutcomes(outcomes);
        const participants = ResponseData.ml.pico_span.population;
        setParticipants(participants);
        const punchline = ResponseData.ml.punchlines;
        setPunchline(punchline);
        const year = ResponseData.dubious.year;
        setYear(year);
        const pages = ResponseData.dubious.pages;
        setPages(pages);
        const pmid = ResponseData.dubious.pmid;
        setPmid(pmid);
        const judgement = ResponseData.ml.bias;
        setJudgment(judgement);
        const rct = ResponseData.ml.rct;
        setRct(rct);
        const findings = ResponseData.ml.finding_direction;
        setFindings(findings);
        const multidata = Response2.article_data;
        setMultidata(multidata);
        setisLoadingMultidata(false);
        store.dispatch(
          setLoading({ apiName: "getReviewData(IB)", isLoading: false })
        );
      })
      .catch(function (error) {
        console.log(error);
        setisLoadingMultidata(false);
        store.dispatch(
          setLoading({ apiName: "getReviewData(IB)", isLoading: false })
        );
      })
      .finally(function () {
        setisLoadingMultidata(false);
        store.dispatch(
          setLoading({ apiName: "getReviewData(IB)", isLoading: false })
        );
      });
  };

  const getReviewEvidence = () => {
    setisLoadingData(true);
    store.dispatch(
      setLoading({ apiName: "getReviewEvidence(IB)", isLoading: true })
    );

    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;
    const studyId = localStorage.getItem("studyId");

    var config = {
      method: "get",
      url: `${API_Link}getReviewEvidence?review_id=${studyId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    axios(config)
      .then(function (response) {
        const APIresponse = response.data.evidences;
        console.log("DATA is here :", APIresponse);
        setData(APIresponse);
        setisLoadingData(false);
        store.dispatch(
          setLoading({ apiName: "getReviewEvidence(IB)", isLoading: false })
        );
      })
      .catch(function (error) {
        console.log(error);
        setisLoadingData(false);
        store.dispatch(
          setLoading({ apiName: "getReviewEvidence(IB)", isLoading: false })
        );
      })
      .finally(function () {
        setisLoadingData(false);
        store.dispatch(
          setLoading({ apiName: "getReviewEvidence(IB)", isLoading: false })
        );
      });
  };

  const getPicoSearches = () => {
    store.dispatch(
      setLoading({ apiName: "getPicoSearches(IB)", isLoading: true })
    );

    setisLoadingPicoSearchs(true);
    let review_id = localStorage.getItem("studyId");

    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;

    var config = {
      method: "get",
      url: `${API_Link}getPicoSearches?review_id=${review_id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    axios(config)
      .then(function (response) {
        setPicoSearches(
          response.data.picoSearches.filter(
            (item) => item.database !== "RISimport"
          )
        );
        setisLoadingPicoSearchs(false);
        store.dispatch(
          setLoading({ apiName: "getPicoSearches(IB)", isLoading: false })
        );
      })
      .catch(function (error) {
        console.log(error);
        setisLoadingPicoSearchs(false);
        store.dispatch(
          setLoading({ apiName: "getPicoSearches(IB)", isLoading: false })
        );
      })
      .finally(function () {
        setisLoadingPicoSearchs(false);
        store.dispatch(
          setLoading({ apiName: "getPicoSearches(IB)", isLoading: false })
        );
      });
  };

  const PrismaComponent = () => {
    setisLoadingPrismaValue(true);
    store.dispatch(setLoading({ apiName: "Prisma(IB)", isLoading: true }));

    const user = JSON.parse(localStorage.getItem("user"));
    const studyId = localStorage.getItem("studyId");
    const token = user?.token;

    var config = {
      method: "get",
      url: `${API_Link}getPrismaCounts?review_id=${studyId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };

    axios(config)
      .then(function (response) {
        const resData = response;
        setPrismaValue(resData.data.counts);
        console.log("getPrisma", prismaValue);
        console.warn("reasons", resData.data.counts[0].excluded);
        setReasons(resData.data.counts[0].excluded);
        setisLoadingPrismaValue(false);
        store.dispatch(setLoading({ apiName: "Prisma(IB)", isLoading: false }));
      })
      .catch(function (error) {
        console.log(error);
        setisLoadingPrismaValue(false);
        store.dispatch(setLoading({ apiName: "Prisma(IB)", isLoading: false }));
      })
      .finally(function () {
        setisLoadingPrismaValue(false);
        store.dispatch(setLoading({ apiName: "Prisma(IB)", isLoading: false }));
      });
  };

  //
  const getReviewBiases = () => {
    store.dispatch(
      setLoading({ apiName: "getReviewBiases(IB)", isLoading: true })
    );
    const user = JSON.parse(localStorage.getItem("user"));
    const studyId = localStorage.getItem("studyId");
    const token = user?.token;

    var config = {
      method: "get",
      url: `${API_Link}getReviewBiases?review_id=${studyId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };

    axios(config)
      .then(function (response) {
        const resData = response;
        setBiasesData(resData.data.biases);
        store.dispatch(
          setLoading({ apiName: "getReviewBiases(IB)", isLoading: false })
        );
      })
      .catch(function (error) {
        console.log(error);
        store.dispatch(
          setLoading({ apiName: "getReviewBiases(IB)", isLoading: false })
        );
      })
      .finally(function () {
        store.dispatch(
          setLoading({ apiName: "getReviewBiases(IB)", isLoading: false })
        );
      });
  };

  const getReviewJudgements = () => {
    setisLoadingJudgementData(true);
    store.dispatch(
      setLoading({ apiName: "getReviewJudgements(IB)", isLoading: true })
    );

    const user = JSON.parse(localStorage.getItem("user"));
    const studyId = localStorage.getItem("studyId");
    const token = user?.token;

    var config = {
      method: "get",
      url: `${API_Link}getReviewJudgements?review_id=${studyId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };

    axios(config)
      .then(function (response) {
        const resData = response;
        setJudgmentData(resData.data);
        console.log("JudgmentData: ", resData.data);
        setisLoadingJudgementData(false);
        store.dispatch(
          setLoading({ apiName: "getReviewJudgements(IB)", isLoading: false })
        );
      })
      .catch(function (error) {
        console.log(error);
        setisLoadingJudgementData(false);
        store.dispatch(
          setLoading({ apiName: "getReviewJudgements(IB)", isLoading: false })
        );
      })
      .finally(function () {
        setisLoadingJudgementData(false);
        store.dispatch(
          setLoading({ apiName: "getReviewJudgements(IB)", isLoading: false })
        );
      });
  };
  const getReviewPico = () => {
    setisLoadingPicoData(true);
    const user = JSON.parse(localStorage.getItem("user"));
    const studyId = localStorage.getItem("studyId");
    const token = user?.token;

    var config = {
      method: "get",
      url: `${API_Link}getReviewPicoSentences?review_id=${studyId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    localStorage.setItem("pdfAId", "");
    axios(config)
      .then(function (response) {
        const resData = response;
        setPicoData(resData.data);
        console.log("Pico: ", resData.data);
        setisLoadingPicoData(false);
      })
      .catch(function (error) {
        console.log(error);
        setisLoadingPicoData(false);
      });
  };

  //
  const headings1 = [
    { id: 1, headingText: "Random sequence generation" },
    { id: 2, headingText: "Allocation concealment" },
    { id: 3, headingText: "Blinding of participants and personnel" },
    { id: 4, headingText: "Blinding of outcome assessment" },
    { id: 5, headingText: "Incomplete outcome data" },
    { id: 6, headingText: "Selective reporting" },
  ];
  const headings2 = [
    { id: 1, headingText: "Participants" },
    { id: 2, headingText: "Intervention" },
    { id: 3, headingText: "OutComes" },
  ];
  const output = [];

  const tableRows = [];
  if (judgementData.judgements) {
    var topLevelKeys = Object.keys(judgementData.judgements);
    console.log("output", topLevelKeys);
  }
  if (picoData.picos) {
    var picoIds = Object.keys(picoData.picos);
    console.log("pico ids", picoIds);
  }
  useEffect(() => {
    getReviewEvidence();
    getReviewData();
    getPicoSearches();
    PrismaComponent();
    getReviews();
    getReviewBiases();
    getReviewJudgements();
    getReviewPico();
  }, []);

  const judgements = judgementData.judgements;
  // console.log("Data123:", judgementData.judgements)
  const picos = picoData.picos;
  // console.log("Data1111: ", judgementData)

  return (
    <div
      style={{
        paddingLeft: "20px",
        paddingRight: "20px",
        marginBottom: "50px",
      }}
      id="exportContent"
    >
      <p style={{ textAlign: "right" }}>
        <img src={logo} />
      </p>
      <div style={{ paddingLeft: "10%" }}>
        <div
          style={{ fontSize: "28px", fontWeight: "bold", textAlign: "start" }}
        >
          INFORMATION BRIEF (RAPID REVIEW)
        </div>
        <div
          style={{
            fontSize: "20px",
            fontWeight: "bold",
            textAlign: "start",
            height: "120px",
            color: "#d8b20e",
            marginTop: "10px",
          }}
        >
          {title1}
        </div>
        <div
          style={{
            textAlign: "left",
            fontSize: "18px",
            fontWeight: "bold",
            color: "#767171",
            marginBottom: "30px",
          }}
        >
          Malaysian Health Technology Assessment Section (MaHTAS)<br></br>
          Medical Development Division
          <br />
          Ministry of Health Malaysia
          <br />
          006/2020
        </div>
      </div>
      <p style={{ textAlign: "right" }}>
        <img src={mark} />
      </p>
      <div
        style={{
          textAlign: "start",
          backgroundColor: "lightgray",
          padding: "15px",
          paddingBottom: "20px",
        }}
      >
        <strong>DISCLAIMER</strong>
        <br />
        This information brief is a brief report, prepared on an urgent basis,
        to assist health care decision-makers and health care professionals in
        making well-informed decisions related to the use of health technology
        in health care system, which draws on restricted review from analysis of
        best pertinent literature available at the time of development. This
        report has not been subjected to an external review process. While
        effort has been made to do so, this report may not fully reflect all
        scientific research available. Other relevant scientific findings may
        have been reported since the completion of this report. MaHTAS is not
        responsible for any errors, injury, loss or damage arising or relating
        to the use (or misuse) of any information, statement or content of this
        report or any of the source materials.
        <br />
        <br />
        <p>
          Please contact htamalaysia@moh.gov.my if further information is
          required.{" "}
        </p>
      </div>
      <div
        style={{ textAlign: "left", marginTop: "20px", marginBottom: "30px" }}
      >
        <p>Malaysian Health Technology Assessment Section (MaHTAS)</p>
        <p>Medical Development Division </p>
        <p>Ministry of Health Malaysia</p>
        <p>Level 4, Block E1, Precinct 1</p>
        <p>Government Office Complex</p>
        <p>62590, Putrajaya</p>
        <p>Tel: 603 8883 1229</p>
        <div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
          Available online via the official Ministry of Health Malaysia website:
          http://www.moh.gov.my
        </div>
        <div
          style={{
            padding: "10px",
            height: "100px",
            backgroundColor: "#fff9a6",
          }}
        >
          <strong>SUGGESTED CITATION:</strong> Roza S and Izzuna MMG. Free Style
          Libre flash glucose monitoring. Information Brief. Ministry of Health
          Malaysia: Malaysian Health Technology Assessment Section (MaHTAS);
          2020. 67 p. Report No.: 006/2020
        </div>
        <br />
        <div
          style={{
            padding: "10px",
            height: "100px",
            backgroundColor: "#fff9a6",
          }}
        >
          <strong>DISCLOSURE: </strong>The author of this report has no
          competing interest in this subject and the preparation of this report
          is entirely funded by the Ministry of Health Malaysia.
        </div>
        <div
          style={{ textAlign: "center", fontWeight: "bold", padding: "10px" }}
        >
          <p>
            <span style={{ color: "green", marginRight: "10px" }}>
              {" "}
              TITLE:{" "}
            </span>
            {title1}
          </p>
        </div>
        <div
          style={{
            padding: "10px",
            backgroundColor: "#ecd264",
            border: "1px solid black",
          }}
        >
          <strong>Abstract</strong>{" "}
        </div>{" "}
        <br />
        {abstract?.map((item, index) => (
          <p
            key={index}
            style={{
              textAlign: "justify",
              fontFamily: "sans-serif",
              fontSize: "16px",
            }}
          >
            {item}
          </p>
        ))}{" "}
        <br />
        <br />
        <div
          style={{
            padding: "10px",
            backgroundColor: "#ecd264",
            border: "1px solid black",
          }}
        >
          <strong>PURPOSE </strong>
        </div>
        <p>
          To provide brief information on the efficacy/effectiveness, safety and
          cost-effectiveness of…
        </p>
        {/* <div
          style={{
            padding: "10px",
            backgroundColor: "#ecd264",
            border: "1px solid black",
          }}
        >
          <strong>Background</strong>{" "}
        </div>{" "} */}
        <br />
        <div
          style={{
            padding: "10px",
            backgroundColor: "#ecd264",
            border: "1px solid black",
          }}
        >
          <strong>CHARACTERISTICS OF STUDIES </strong>
        </div>
        <br />
        {isLoadingMultidata ? (
          <div className="preload">
            <img src={gif} alt="Loading..." />
          </div>
        ) : (
          <>
            {biasesData?.map((biasesItem) => {
              const articleId = biasesItem.article_id.toString();

              // Find corresponding data for the same articleId in topLevelKeys and picoIds
              const topLevelKeyData = topLevelKeys?.includes(articleId)
                ? articleId
                : null;
              const picoData = picoIds?.includes(articleId) ? articleId : null;

              return (
                <div key={articleId}>
                  {/* Biases Data */}
                  <>
                    <p>
                      <strong>{biasesItem.author_year}</strong>
                    </p>
                    <table
                      style={{ border: "1px solid black", padding: "2px" }}
                    >
                      <tr style={{ border: "1px solid black", padding: "2px" }}>
                        <td
                          style={{
                            color: "#219ebc",
                            backgroundColor: "#d9e2f3",
                            padding: "5px",
                          }}
                        >
                          Participants
                        </td>
                        <td
                          style={{
                            border: "1px solid black",
                            textAlign: "justify",
                            padding: "5px",
                          }}
                        >
                          {biasesItem.population}
                        </td>
                      </tr>
                      <tr style={{ border: "1px solid black", padding: "2px" }}>
                        <td
                          style={{
                            color: "#219ebc",
                            backgroundColor: "#d9e2f3",
                            padding: "5px",
                          }}
                        >
                          Interventions
                        </td>
                        <td
                          style={{
                            border: "1px solid black",
                            textAlign: "justify",
                            padding: "5px",
                          }}
                        >
                          {biasesItem.interventions}
                        </td>
                      </tr>
                      <tr style={{ border: "1px solid black", padding: "2px" }}>
                        <td
                          style={{
                            color: "#219ebc",
                            backgroundColor: "#d9e2f3",
                            padding: "5px",
                          }}
                        >
                          Outcomes
                        </td>
                        <td
                          style={{
                            border: "1px solid black",
                            textAlign: "justify",
                            padding: "5px",
                          }}
                        >
                          {biasesItem.outcomes}
                        </td>
                      </tr>
                    </table>
                  </>

                  {/* Top Level Keys */}
                  {topLevelKeyData && (
                    <table className="table table-bordered table-striped mt-4 judgement-table">
                      <thead>
                        <tr>
                          <th style={styles.thStyling}>Bias</th>
                          <th style={styles.thStyling}>Judgment</th>
                          <th style={styles.thStyling}>Support for judgment</th>
                        </tr>
                      </thead>
                      <tbody>
                        {headings1?.map((item, index) => {
                          // Match heading ID to bias field in biasesItem
                          const biasField = {
                            1: biasesItem?.random_sequence_generation,
                            2: biasesItem?.allocation_concealment,
                            3: biasesItem?.participants_personnel_blinding,
                            4: biasesItem?.outcome_assessment_blinding,
                            5: biasesItem?.incomplete_outcome_data,
                            6: biasesItem?.selective_reporting,
                          }[item.id];

                          return (
                            <tr key={index}>
                              <td>{item?.headingText}</td>
                              <td>{biasField}</td>
                              <td>
                                {judgements[articleId]?.[item.id]?.map(
                                  (judgement, idx) => (
                                    <div key={idx}>
                                      <span>{judgement?.support_text}</span>
                                      <Link
                                        className="Editpdf-icon"
                                        to={`/biasbot/${articleId}`}
                                      >
                                        <img
                                          src={pdficon}
                                          alt=""
                                          height="17px"
                                        />
                                        <span className="tooltiptextannotation">
                                          Jump to Annotation
                                        </span>
                                      </Link>
                                    </div>
                                  )
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}

                  {/* PICO Data */}
                  {picoData && (
                    <table className="table table-bordered table-striped mt-4 judgement-table">
                      <thead>
                        <tr>
                          <th style={styles.thStyling}>PICO</th>
                          <th style={styles.thStyling}>Support for Pico</th>
                        </tr>
                      </thead>
                      <tbody>
                        {headings2?.map((item, index) => (
                          <tr key={index}>
                            <td>{item?.headingText}</td>
                            <td>
                              {picos[articleId]?.[index + 1]?.map(
                                (pico, idx) => (
                                  <div key={idx}>
                                    <span>{pico?.pico_text}</span>
                                    <Link
                                      to={`/picobot/${articleId}`}
                                      className="Editpdf-icon"
                                    >
                                      <img src={pdficon} alt="" height="17px" />
                                      <span className="tooltiptextannotation">
                                        Jump to Annotation
                                      </span>
                                    </Link>
                                  </div>
                                )
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              );
            })}
          </>
        )}
        {isLoadingJudgementData ? (
          <div className="preload">
            <img src={gif} alt="Loading..." />
          </div>
        ) : (
          <></>
        )}
        <br />
        <div
          style={{
            padding: "10px",
            backgroundColor: "#ecd264",
            border: "1px solid black",
          }}
        >
          <strong>EVIDENCE SUMMARY </strong>
        </div>
        <p>
          A total of ….. titles were retrieved from the scientific databases
          such as Medline, EBM Reviews, EMBASE via OVID, PubMed and from general
          search engines [Google Scholar and US Food and Drug Administration
          (USFDA)], using the search term; …….. Last search was conducted on…...
          X articles were found to be relevant and included in this review which
          comprised of …………
        </p>
        {/* <div
          style={{
            padding: "10px",
            backgroundColor: "#ecd264",
            border: "1px solid black",
          }}
        >
          <strong>EFFICACY/ EFFECTIVENESS </strong>
        </div> */}
        <br />
        <div
          style={{
            padding: "10px",
            backgroundColor: "#ecd264",
            border: "1px solid black",
          }}
        >
          <strong>Risk of bias table </strong>
        </div>
        {isLoadingMultidata ? (
          <div className="preload">
            <img src={gif} alt="Loading..." />
          </div>
        ) : (
          <>
            <table
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                borderCollapse: "collapse",
                padding: 0,
                marginTop: "10px",
              }}
            >
              <tr className="bias-header-row">
                <th
                  style={{
                    verticalAlign: "bottom",
                    textAlign: "left",
                    margin: "20px",
                    padding: "8px",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  trial
                </th>
                <th
                  style={{
                    verticalAlign: "bottom",
                    textAlign: "left",
                    padding: "8px",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  design
                </th>
                {judgement?.map((item, index) => (
                  <th
                    key={index}
                    style={{
                      height: "70px",
                      whiteSpace: "normal",
                      padding: "8px",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    <div
                      style={{
                        width: "100px",
                        fontSize: "14px",
                        padding: "10px",
                      }}
                    >
                      <span>{item.domain}</span>
                    </div>
                  </th>
                ))}
              </tr>
              {multidata?.map((item, index) => (
                <tr key={index}>
                  <td
                    style={{
                      fontSize: "12px",
                      padding: "10px",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {item.pubmed.length === 0
                      ? ""
                      : item?.pubmed?.authors
                          ?.map(
                            (author) =>
                              `${author?.forename
                                .split(" ")
                                ?.map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() + word.slice(1)
                                )
                                .join(" ")} ${author?.lastname
                                .split(" ")
                                ?.map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() + word.slice(1)
                                )
                                .join(" ")}`
                          )
                          .join(", ")}{" "}
                    {item?.pubmed?.year}
                    {item?.grobid?.length === 0
                      ? ""
                      : item?.grobid?.authors
                          ?.map(
                            (author) =>
                              `${author?.forename
                                .split(" ")
                                ?.map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() + word.slice(1)
                                )
                                .join(" ")} ${author?.lastname
                                .split(" ")
                                ?.map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() + word.slice(1)
                                )
                                .join(" ")}`
                          )
                          .join(", ")}{" "}
                    {item?.grobid?.year}
                  </td>
                  <td
                    style={{ padding: "10px", borderBottom: "1px solid #ddd" }}
                  >
                    {item?.ml?.rct?.is_rct === false ? (
                      <p>Not Rct</p>
                    ) : (
                      <p>Rct</p>
                    )}
                  </td>
                  {item?.ml?.bias?.map((bi, biasIndex) => (
                    <td
                      key={biasIndex}
                      style={{
                        backgroundColor:
                          bi.judgement === "high/unclear" ? "red" : "green",
                        color: "white",
                        textAlign: "center",
                        width: "40px",
                        padding: "10px",
                        borderBottom: "1px solid #ddd",
                      }}
                    >
                      {bi.judgement === "high/unclear" ? "?" : "+"}
                    </td>
                  ))}
                </tr>
              ))}
            </table>
            <br />
          </>
        )}
        <div
          style={{
            padding: "10px",
            backgroundColor: "#ecd264",
            border: "1px solid black",
            marginBottom: "20px",
          }}
        >
          <strong>Trail Summaries </strong>
        </div>
        {isLoadingMultidata ? (
          <div className="preload">
            <img src={gif} alt="Loading..." />
          </div>
        ) : (
          <table
            className="table table-striped blue-bg-th-table"
            style={{
              borderCollapse: "collapse",
              width: "100%",
              border: "1px solid black",
              marginTop: "15px",
            }}
          >
            <tr style={{ border: "1px solid black" }}>
              <th
                style={{
                  border: "1px solid black",
                  textAlign: "center",
                  color: "#219ebc",
                  backgroundColor: "#d9e2f3",
                }}
              >
                {" "}
                n{" "}
              </th>
              <th
                style={{
                  border: "1px solid black",
                  textAlign: "center",
                  color: "#219ebc",
                  backgroundColor: "#d9e2f3",
                }}
              >
                {" "}
                Participants{" "}
              </th>

              <th
                style={{
                  border: "1px solid black",
                  textAlign: "center",
                  color: "#219ebc",
                  backgroundColor: "#d9e2f3",
                }}
              >
                {" "}
                Interventions{" "}
              </th>

              <th
                style={{
                  border: "1px solid black",
                  textAlign: "center",
                  color: "#219ebc",
                  backgroundColor: "#d9e2f3",
                }}
              >
                {" "}
                Outcomes{" "}
              </th>

              <th
                style={{
                  border: "1px solid black",
                  textAlign: "center",
                  color: "#219ebc",
                  backgroundColor: "#d9e2f3",
                }}
              >
                {" "}
                Punchline{" "}
              </th>

              <th
                style={{
                  border: "1px solid black",
                  textAlign: "center",
                  color: "#219ebc",
                  backgroundColor: "#d9e2f3",
                }}
              >
                {" "}
                Finding{" "}
              </th>
            </tr>
            {interventions.length === 0 ||
            participants.length === 0 ||
            outcomes.length === 0 ||
            punchline.length === 0 ? (
              <td colspan="9" className="text-center bg-danger text-light">
                {" "}
                <strong>You don't have any Trail Summaries</strong>{" "}
              </td>
            ) : (
              multidata?.map((item) => {
                console.log("item: ", item);
                return (
                  <tr>
                    <td style={styles.tdStyling}>
                      {item?.grobid?.title && (
                        <p>
                          <strong>Title: </strong> {item?.grobid?.title}
                        </p>
                      )}
                      {item?.grobid?.authors && (
                        <p>
                          <strong>Authors: </strong>{" "}
                          {item?.grobid?.authors
                            ?.map(
                              (author) =>
                                `${author?.forename
                                  .split(" ")
                                  ?.map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1)
                                  )
                                  .join(" ")} ${author?.lastname
                                  .split(" ")
                                  ?.map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1)
                                  )
                                  .join(" ")}`
                            )
                            .join(", ")}
                        </p>
                      )}
                      {item?.grobid?.journal && (
                        <p>
                          <strong>Journal: </strong> {item?.grobid?.journal}
                        </p>
                      )}
                    </td>
                    <td style={styles.tdStyling}>
                      {item.ml?.pico_span?.population?.map((inter) => (
                        <div>
                          <span>{inter}</span>
                        </div>
                      ))}
                    </td>
                    <td style={styles.tdStyling}>
                      {item?.ml?.pico_span?.interventions?.map((inter) => (
                        <div>
                          <span>{inter}</span>
                        </div>
                      ))}
                    </td>
                    <td style={styles.tdStyling}>
                      {item?.ml?.pico_span?.outcomes?.map((inter) => (
                        <div>
                          <span>{inter}</span>
                        </div>
                      ))}
                    </td>
                    <td style={styles.tdStyling}>{item?.ml?.punchlines}</td>
                    <td style={styles.tdStyling}>
                      {item?.ml?.finding_direction}
                    </td>
                  </tr>
                );
              })
            )}
          </table>
        )}
        {/* <div
          style={{
            padding: "10px",
            backgroundColor: "#ecd264",
            border: "1px solid black",
          }}
        >
          <strong>SAFETY </strong>
        </div> */}
        <br />
        <div
          style={{
            padding: "10px",
            backgroundColor: "#ecd264",
            border: "1px solid black",
          }}
        >
          <strong>Evidence Table </strong>
        </div>
        <br/>
        {isLoadingData ? (
          <div className="preload">
            <img src={gif} alt="Loading..." />
          </div>
        ) : (
          <>
            <EvidenceTableSingle />
          </>
        )}
        <br />
        <div
          style={{
            padding: "10px",
            backgroundColor: "#ecd264",
            border: "1px solid black",
          }}
        >
          <strong>Pico Result </strong>
        </div>
        {isLoadingPicoSearchs ? (
          <div className="preload">
            <img src={gif} alt="Loading..." />
          </div>
        ) : (
          <div>
            {picoSearchs?.length > 0 ? (
              picoSearchs?.map((search, index) => (
                <tr key={index}>
                  {" "}
                  <strong>
                    <br />
                    <td>
                      {index + 1} {search?.database}
                    </td>
                    <td>{search?.population}</td>
                    <td>{search?.intervention}</td>
                    <td>{search?.comparison}</td>
                    <td>{search?.outcome}</td>
                    <td>{search?.included}</td>
                    <td>{search?.total_records}</td>
                  </strong>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className="text-center text-muted">
                  You have no pico search History
                </td>
              </tr>
            )}
          </div>
        )}
        {/* <div
          style={{
            padding: "10px",
            backgroundColor: "#ecd264",
            border: "1px solid black",
          }}
        >
          <strong>COST-EFFECTIVENESS (If any) </strong>
        </div> */}
        {/* <br />
        <div
          style={{
            padding: "10px",
            backgroundColor: "#ecd264",
            border: "1px solid black",
          }}
        >
          <strong>CONCLUSION </strong>
        </div> */}
        <br />
        <div
          style={{
            padding: "10px",
            backgroundColor: "#ecd264",
            border: "1px solid black",
          }}
        >
          <strong>REFERENCES </strong>
        </div>
        <br />
        {isLoadingMultidata ? (
          <div className="preload">
            <img src={gif} alt="Loading..." />
          </div>
        ) : (
          <div>
            {multidata?.map((item, index) => {
              return (
                <>
                  {item?.dubious?.length === 0 ? (
                    <p style={{ justifyContent: "space-between" }}>
                      {index + 1}. <span style={{ marginLeft: "5px" }}></span>
                      {item.pubmed.length === 0
                        ? ""
                        : item?.pubmed?.authors[0]?.forename}{" "}
                      ,
                      {item?.pubmed?.length === 0
                        ? ""
                        : item?.pubmed?.authors[0]?.lastname}
                      ,{item?.pubmed?.title} , {item.pubmed.pages}, PMID:{" "}
                      {item?.pubmed?.pmid}
                    </p>
                  ) : (
                    <p style={{ justifyContent: "space-between" }}>
                      {index + 1}. <span style={{ marginLeft: "5px" }}></span>
                      {item?.dubious?.length === 0
                        ? ""
                        : item?.dubious?.authors[0]?.forename}{" "}
                      ,
                      {item?.dubious?.length === 0
                        ? ""
                        : item?.dubious?.authors[0]?.lastname}
                      ,{item?.dubious?.title} , {item?.dubious?.pages}, PMID:{" "}
                      {item?.dubious?.pmid}
                    </p>
                  )}
                </>
              );
            })}
          </div>
        )}
        <br />
        <div
          style={{
            padding: "10px",
            backgroundColor: "#ecd264",
            border: "1px solid black",
            marginBottom: "20px",
          }}
        >
          <strong>Prepared by </strong>
        </div>
        <p>Dr. Roza Sarimin</p>
        <p>Public Health Physician </p>
        <p>Senior Principle Assistant Director</p>
        <p>Health Technology Assessment Section (MaHTAS)</p>
        <p>Medical Development Division</p>
        <p>Ministry of Health Malaysia</p>
        <div
          style={{
            padding: "10px",
            backgroundColor: "#ecd264",
            border: "1px solid black",
            marginBottom: "20px",
          }}
        >
          <strong>Reviewed by</strong>
        </div>
        <p>Dr. Izzuna Mudla Mohamed Ghazali</p>
        <p>Public Health Physician</p>
        <p>Deputy Director</p>
        <p>Health Technology Assessment Section (MaHTAS)</p>
        <p>Medical Development Division</p>
        <p>Ministry of Health Malaysia</p>
        <div style={{ marginTop: "20px" }}>
          <strong>26 June 2020</strong>
        </div>
        <br />
        {isLoadingPrismaValue ? (
          <div className="preload">
            <img src={gif} alt="Loading..." />
          </div>
        ) : (
          <div>
            {prismaValue &&
              prismaValue?.length > 0 &&
              prismaValue?.map(() => {
                return (
                  <>
                    <div
                      style={{
                        padding: "10px",
                        backgroundColor: "#ecd264",
                        border: "1px solid black",
                        marginBottom: "20px",
                      }}
                    >
                      <strong>Prisma FlowChart </strong>
                    </div>
                    <div className="container">
                      <div className="row pt-5">
                        <div className="col-sm-12 col-md-3 col-lg-2 mt-2">
                          <div className="identification">
                            <p className="text">Identification</p>
                          </div>
                        </div>
                        <div className="col-col-sm-12 col-md-9 col-lg-10">
                          <div className="row mb-3">
                            <div className="col-sm-12 col-md-12 col-lg-6 mt-2 ">
                              <div className="Number1972">
                                Number of records identified through electronic
                                databases searching (n=
                                {prismaValue[0]?.onlineSearch})
                              </div>
                            </div>

                            <div className="col-sm-12 col-md-12 col-lg-6 mt-2">
                              <div className="Number53">
                                Number of additional records identified from
                                other sources (n={prismaValue[0]?.otherSources})
                              </div>
                            </div>
                          </div>

                          <div className="row ">
                            <div className="col-6">
                              <span className="arrow-icon-prisma">
                                {/* <i className='bi bi-arrow-down-short'></i> */}
                                ↓
                              </span>
                            </div>
                            <div className="col-6">
                              <span className="arrow-icon-prisma">↓</span>
                            </div>
                          </div>

                          <div className="row pt-2 mb-3 ">
                            <div className="col-12">
                              <div className="Num2055">
                                Number of records after duplicates removed (n=
                                {prismaValue[0]?.abstract_articles_count})
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12 col-md-3"></div>
                        <div className="col-sm-12 col-md-9 col-lg-10">
                          <span className="arrow-icon-prisma">↓</span>
                        </div>
                      </div>

                      <div className="row ">
                        <div className="col-sm-12 col-md-3 col-lg-2 mt-2">
                          <div className="Screening">
                            <p className="text">Screening</p>
                          </div>
                          <div className="row pt-2">
                            <div className="col-sm-12 col-md-3 col-lg-2 ">
                              <div className="included">
                                <p className="text">included</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-col-sm-12 col-md-9 col-lg-10">
                          <div className="row mb-3">
                            <div className="col-sm-12 col-md-12 col-lg-1 "></div>
                            <div className="col-sm-12 col-md-12 col-lg-5 mt-2">
                              <div className="num_1925">
                                Number of records screened (n=
                                {prismaValue[0]?.abstract_articles_count})
                              </div>
                            </div>

                            <div className="col-sm-12 col-md-12 col-lg-1">
                              <span className="arrow-icon-prisma text-icon arrow-icon-prisma-right">
                                {/* <i className='bi bi-arrow-down-short'></i> */}
                                →
                              </span>
                            </div>

                            <div className="col-sm-12 col-md-12 col-lg-5 mt-2 ">
                              <div className="num1200">
                                Number of records excluded (n=
                                {prismaValue[0]?.abstract_articles_count -
                                  prismaValue[0]?.fulltext_articles_count}
                                )
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-7">
                              <span className="arrow-icon-prisma">
                                {/* <i className='bi bi-arrow-down-short'></i> */}
                                ↓
                              </span>
                            </div>
                          </div>

                          <div className="row ">
                            <div className="col-sm-12 col-md-12 col-lg-1 col-xxl-1 "></div>
                            <div className="col-sm-12 col-md-12 col-lg-5 col-xxl-5 ">
                              <div className="row mb-3">
                                <div className="col">
                                  <div className="num685">
                                    Number of full-text articles assessed for
                                    eligibility (n=
                                    {prismaValue[0]?.fulltext_articles_count})
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-12 col-md-12 col-lg-12">
                                <span className="arrow-icon-prisma">
                                  {/* <i className='bi bi-arrow-down-short'></i> */}
                                  ↓
                                </span>
                              </div>
                              <div className="row ">
                                <div className="col">
                                  <div className="mt-2 yelllowbox">
                                    Number of full-text articles included in
                                    qualitative synthesis (n=
                                    {prismaValue[0]?.included_articles_count})
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-1 col-xxl-1 ">
                              <span className="arrow-icon-prisma text-icon arrow-icon-prisma-right">
                                {/* <i className='bi bi-arrow-down-short'></i> */}
                                →
                              </span>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-5 col-xxl-5">
                              <div className="num432">
                                Number of full-text articles excluded (n=
                                {prismaValue[0]?.fulltext_articles_count -
                                  prismaValue[0]?.included_articles_count}
                                ) <br></br> Reasons:
                                {reasons &&
                                  reasons
                                    .filter(
                                      (exclusion) => exclusion?.stage === 3
                                    )
                                    ?.map(({ purpose, total }, index) => {
                                      return (
                                        <small>
                                          <br></br>
                                          {purpose?.label} (n = {total})
                                        </small>
                                      );
                                    })}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
          </div>
        )}
      </div>
    </div>
  );
}
export default IB;
